var path = 'app/login/login.html';
var html = "<login-header></login-header> <div class=view autoscroll=true> <login-form></login-form> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/main/assets/app/login/login.html
 ** module id = 227
 ** module chunks = 2
 **/